/* eslint-disable no-restricted-syntax,consistent-return */
import store from '@/store';
import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';
import Contract from '@/models/contract';
import { COLOR_MAP, getColorForPalletteCandidate } from '@/components/pages/page-election-map-new/election-map/election-map.vue';
import { capitalizeFirstLetter, getLeadingTradedContract, toCents } from '@/utils/helpers';

export default {
  props: {
    stateCode: {
      type: String,
    },
    stateName: {
      type: String,
    },
    marketData: {
      type: Object,
    },
    type: {},
  },
  components: {
    marketChangePrice,
  },
  data() {
    return {
      capitalizeFirstLetter,
      toCents,
    };
  },
  computed: {
    isSenate() {
      return this.type === 'senate';
    },
    color() {
      return this.pallette.color;
    },
    showNote() {
      const statesForNote = ['ME', 'NE'];
      return statesForNote.includes(this.stateCode) && !this.isSenate;
    },
    winnerMode() {
      return this.targetContract !== null;
      // return get(this.marketData, 'status', 'Open') === constants.MARKET_CLOSED;
    },
    winnerBgColorStyleModifiers() {
      return {
        'background-color': this.color,
      };
    },
    targetContract() {
      return getLeadingTradedContract(this.marketData.contracts || []);
    },
    targetContractInstance() {
      return new Contract(this.targetContract || {});
    },
    classModifiers() {
      return {
        'market-state-tooltip': true,
      };
    },
    styleModifiers() {
      return {
        border: `4px solid ${this.color}`,
      };
    },
    titleClassModifiers() {
      // const lightPallettes = [
      //   COLOR_MAP.GRAY[0],
      //   COLOR_MAP.BLUE[0],
      //   COLOR_MAP.RED[0],
      // ];
      return {
        'market-state-tooltip__state-name': true,
        // 'market-state-tooltip__state-name--light': lightPallettes.includes(this.pallette),
      };
    },
    titleStyleModifiers() {
      return {
        background: this.color,
      };
    },
    pallette() {
      if (!this.targetContract) {
        return COLOR_MAP.GRAY[1];
      }

      const pallette = getColorForPalletteCandidate(this.targetContract.contractName);
      const factor = pallette[0].from + this.targetContract.lastTradePrice;
      for (const item of pallette) {
        if (factor <= item.to) {
          return item;
        }
      }

      return pallette[pallette.length - 1];
    },
    contracts() {
      return (this.marketData.contracts || []).map(i => new Contract(i));
    },
  },
  methods: {
    getNameDisplay(contract) {
      const parts = (contract.contractName || '').split(' ');
      return parts.length > 1 ? parts[1] : contract.contractName;
    },
    contractClassModifiers(contract, index) {
      return {
        'market-state-tooltip__contract': true,
        'market-state-tooltip__contract--with-border': index === 0,
      };
    },
    imageStyleModifiers(contract) {
      return {
        'background-image': `url(${contract.contractImageUrl})`,
      };
    },
    onTooltipClick() {
      if (this.marketData.marketId) {
        window.location.href = `https://www.predictit.org/markets/detail/${this.marketData.marketId}`;
      }
    },
  },
  created() {
    if (this.stateCode !== 'GA2') {
      store.dispatch('market/setMarketMapTooltipVisible', true);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-state-tooltip/market-state-tooltip.js